import { createFileRoute, useParams } from "@tanstack/react-router"
import { Box, LinearProgress, Typography } from "@mui/material"
import { KanbanContextProvider } from "@/components/coreKanban/KanbanContext"
import ProjectPage from "@/components/coreKanban/projectPage/ProjectPage"
import { useProjectPageData } from "@/hooks/useProjectPageData"

function ProjectDetailRoute() {
  const { projectId } = useParams({ from: "/core/kanban/$projectId" })
  const { project, isLoading, isError } = useProjectPageData(projectId)

  if (isLoading) return <LinearProgress sx={{ mt: 4 }} />
  if (isError) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography>Failed to load project.</Typography>
      </Box>
    )
  }
  if (!project) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography>Project not found.</Typography>
      </Box>
    )
  }

  return (
    <KanbanContextProvider>
      <ProjectPage project={project} />
    </KanbanContextProvider>
  )
}

export const Route = createFileRoute("/core/kanban/$projectId")({
  component: ProjectDetailRoute
})
